/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsLogin204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsLogin505Schema = z.any();

export const optionsLoginMutationResponseSchema = z.lazy(() => optionsLogin204Schema);
